var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#33233d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,0A14.041,14.041,0,0,0,2,14c0,7.35,11.55,18.55,12.775,19.775L16,35l1.225-1.225C18.45,32.55,30,21.35,30,14A14.041,14.041,0,0,0,16,0Zm0,30.1C12.15,26.25,5.5,18.375,5.5,14a10.5,10.5,0,1,1,21,0C26.5,18.375,19.85,26.25,16,30.1Z",
    transform: "translate(-2 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13,4a7,7,0,1,0,7,7A7.021,7.021,0,0,0,13,4Zm0,10.5A3.5,3.5,0,1,1,16.5,11,3.51,3.51,0,0,1,13,14.5Z",
    transform: "translate(1 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.72eabc0faddf39c9ae73124caf565cb8.svg";
export { ForwardRef as ReactComponent };